import f from '../../shared/functions.js'
import _ from 'underscore'

class Templates {
    constructor () {

    }

    

    searching({type, value}){
        var a = {}

        a.key = value
        a.type = 'search'
        a.data = {
            search : {type, value}
        }

        a.action = {
            search : value
        }

        return a

    }


    action({type, subtype, component, action, link, data = {}}){

        if(!type) type = 'setting'

        var a = {
            type, component, action, data,
            link,
            key : type + subtype,
            index :  type + subtype
        }

        return a
    }


}

class Actions {
    constructor () {
        this.keys = [
            'themeToggle', 'changePassword'
        ]
    }

    themeToggle() {
        return {
            component : 'themeToggle',
            type : 'setting',
            subtype : 'theme',

            data : {
                label : "labels.theme",
                type : "labels.usersettings"
            }
        }
    }

    changePassword() {
        return {
            type: 'setting',
            subtype: 'changepassword',
            link : "changepassword",
    
         
            data : {
                label : 'common.2901009',
                type : 'labels.usersettings'
            }
        }
    }

}

class Activity {
    constructor({api, user, i18n}){
        this.api = api
        this.user = user
        this.history = []
        this.i18n = i18n

        this.templates = new Templates()
        this.actions = new Actions()
        this.v = '1'

        this.key = 'activity.' + this.v + '.'
    }

    clear(){
        this.history = []

        return this.save()
    }

    save() {

        return this.user.id().then(id => {

            localStorage[this.key + id] = JSON.stringify(this.history)

        }).catch(e => {
            console.error(e)
        })
        
    }

    load(){

        this.history = []

        return this.user.id().then(id => {

            try{
                this.history = JSON.parse(localStorage[this.key + id] || "[]")
            }
            catch(e){}

        }).catch(e => {
            console.error(e)
        })
    }

    template(type, object){

        if(!this.templates[type]){
            return Promise.reject('template')
        }

        return this.add(this.templates[type](object))

    }

    add({
        type, link, key, search, data, action, component, index
    }){
        if(!type || !data || !key) return Promise.reject('parameters {type, key, data}')

        this.history = _.filter(this.history, (h) => {
            return !(h.type == type && h.key == key && 
                (type != 'search' || key.indexOf(h.key) > -1) 
            )
        })

        this.history.unshift({type, component, link, key, search, data, date : new Date(), index : index || (type + key), action})

        this.history = _.first(this.history, 300)

        return this.save()
    }

    remove(type, key){
        this.history = _.filter(this.history, (h) => {
            return h.type != type || h.key != key
        })
    }

    search(value, activity){

        return f.clientsearch(value, activity || this.history, (h) => {
            if(h.search){
                return h.search
            }
            else{
                if (h.data && h.data.label && h.data.type){
                    return this.i18n.t(h.data.label) + " " + this.i18n.t(h.data.type)
                }
            }
        })
    }

    getlastByType(type){

        return _.find(this.history, (h) => {
            return h.type == type
        })
    }

    getlastsByType(type, count = 5){

        var f = 0

        return _.filter(this.history, (h) => {

            if(f > count){
                return false
            }

            if(h.type == type ){
                f++

                return true
            }
        })
    }

    getactions(value){
        var actions = _.map(this.actions.keys, (f) => {
            return this.templates['action'](this.actions[f]()) 
        })

        if(!value){
            return actions
        }

        return this.search(value, actions)
    }
}


export default Activity